/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { Tag } from '@ui/atoms/Tag';
// Provenance → icon + i18n key. Building/company/account/tag origins each carry a
// disambiguating FA icon (matches the prototype's "Applied From" chips).
const APPLIED_FROM = {
    tenant: { icon: 'fa-light fa-globe', key: 'preview.applied_from.company_default' },
    account: { icon: 'fa-light fa-briefcase', key: 'preview.applied_from.account' },
    accounts: { icon: 'fa-light fa-briefcase', key: 'preview.applied_from.account' },
    account_tag: { icon: 'fa-light fa-tag', key: 'preview.applied_from.account_tag' },
    building: { icon: 'fa-light fa-building', key: 'preview.applied_from.building' },
    buildings: { icon: 'fa-light fa-building', key: 'preview.applied_from.building' },
    building_tag: { icon: 'fa-light fa-tag', key: 'preview.applied_from.building_tag' }
};
/**
 * IP-14861 — "Applied From" cell for the Preview tab's in-effect tables. Renders
 * the provenance as a QUI Tag with a leading icon (Building / Company Default /
 * Account Tag …), matching the prototype's chip treatment.
 */
export default function AppliedFromTag({ scope, t }) {
    var _a;
    const meta = (_a = APPLIED_FROM[scope]) !== null && _a !== void 0 ? _a : APPLIED_FROM.tenant;
    return React.createElement(Tag, { label: t(meta.key), variant: "gray", colorStyle: "pastry", icon: meta.icon, readOnly: true });
}
